<template>
  <div class="pc_home">
    <div class="home_banner">
      <div class="home_banner_info">
        <h1>创宇业务安全解决方案，为您一站解决互联网业务风险</h1>
        <h2>
          为互联网平台提供认证体系搭建咨询和实施服务，从准入规则、认证分级、验证流程到结果应用，解决互
        </h2>
        <h2 class="Mt14">
          联网平台上的违规虚假、品牌仿冒、用户欺诈的问题，净化平台服务和交易环境。
        </h2>
        <div class="home_banner_btn" @click="showSubmitDialog">
          <p>立即咨询</p>
        </div>
      </div>
    </div>
    <div class="home_titlenav">
      <nav :class="{ nav_active: activeNav === 'auth' }" @click="navgo('auth')">
        互联网认证
        <i></i>
      </nav>
      <nav
        :class="{ nav_active: activeNav === 'content' }"
        @click="navgo('content')"
      >
        内容安全
        <i></i>
      </nav>
      <nav
        :class="{ nav_active: activeNav === 'audit' }"
        @click="navgo('audit')"
      >
        审核平台
        <i></i>
      </nav>
    </div>
    <div class="home_center">
      <div class="home_center_section home_center_section1" ref="auth">
        <div class="hcs_info">
          <h1>互联网认证</h1>
          <h2 class="Mt32">
            为互联网平台企业&机构认证提供体系搭建咨询和实施服务，
          </h2>
          <h2>从准入规则、认证分级、验证流程到结果展示。</h2>
          <h2 class="Mt8">
            闭环解决互联网平台上的虚假违规用户、仿冒用户、欺诈用户
          </h2>
          <h2>的问题，确保认证后的用户的真实合规性。</h2>
          <div class="hcs_btn" @click="goPage('AptitudeSafe')">了解更多</div>
        </div>
        <img src="@/assets/images/neirong/section1@2x.png" alt="" />
      </div>
      <div class="home_center_section home_center_section2" ref="content">
        <img src="@/assets/images/neirong/section2@2x.png" alt="" />
        <div class="hcs_info">
          <h1>内容安全</h1>
          <h2 class="Mt32">
            为互联网内容平台提供内容安全体系搭建咨询和实施服务。
          </h2>
          <h2 class="Mt8">
            从内容安全规则、恶意分级、过滤流程、应急机制等环节，拦
          </h2>
          <h2>截互联网平台上的违规涉政、涉黄、涉恐等信息，确保互联网</h2>
          <h2>平台的稳定运营。</h2>
          <div class="hcs_btn" @click="goKms()">了解更多</div>
        </div>
      </div>
      <div class="home_center_section home_center_section3" ref="audit">
        <div class="hcs_info">
          <h1>审核平台</h1>
          <h2 class="Mt32">
            为互联网平台企业 & 机构认证 提供体系搭建咨询和实施服务。
          </h2>
          <h2 class="Mt8">
            从准入规则、认证分级、为企业或相关监管机构提供SaaS模式
          </h2>
          <h2>和私有化部署的标准化审核平台产品。</h2>
          <h2 class="Mt8">
            该平台可同时支持：文本、图像、视频、图文、音频的审核；同时
          </h2>
          <h2>具备角色定义、多规则定义、多审核模式定义、运营看板等功能，</h2>
          <h2>可轻松满足百人同时在线作业。</h2>
          <div class="hcs_btn" @click="goPage('AuditPlatform')">了解更多</div>
        </div>
        <img src="@/assets/images/neirong/section3@2x.png" alt="" />
      </div>
    </div>
    <div class="home_bottom">
      <h1>合作客户</h1>
      <div class="home_bottom_section home_bottom_section1">
        <img src="@/assets/images/neirong/weixin@2x.png" alt="" />
        <img src="@/assets/images/neirong/kandian@2x.png" alt="" />
        <img src="@/assets/images/neirong/weishi@2x.png" alt="" />
        <img src="@/assets/images/neirong/qidian@2x.png" alt="" />
        <img src="@/assets/images/neirong/jinshan@2x.png" alt="" />
      </div>
      <div class="home_bottom_section home_bottom_section2">
        <img src="@/assets/images/neirong/douyin@2x.png" alt="" />
        <img src="@/assets/images/neirong/kuaishou@2x.png" alt="" />
        <img src="@/assets/images/neirong/weibo@2x.png" alt="" />
        <img src="@/assets/images/neirong/jingdong@2x.png" alt="" />
      </div>
    </div>
    <submitDialog ref="submitDialog"></submitDialog>
  </div>
</template>

<script>
import submitDialog from '@/components/SubmitDialog'

export default {
  metaInfo: {
    title: '创宇业务安全解决方案|企业认证_商家认证_内容审核-知道创宇云安全',
  },
  name: 'Home',
  data() {
    return {
      activeNav: 'auth',
    }
  },

  components: {
    submitDialog,
  },
  methods: {
    navgo(navName) {
      this.activeNav = navName
      this.$refs[navName].scrollIntoView({
        behavior: 'smooth',
      })
    },
    showSubmitDialog() {
      this.$refs.submitDialog.dialogVisible = true
    },
    handleScrollEmit() {
      const bodyNode = document.getElementsByTagName('html')[0]
      if (bodyNode) {
        if (bodyNode.scrollTop < 360) {
          this.activeNav = 'auth'
        } else {
          this.activeNav = 'content'
        }
      }
    },
    goPage(name) {
      const location = this.$router.resolve({ name })
      window.open(location.href)
    },
    goKms() {
      window.open('http://hjws.yunaq.com/')
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollEmit)
    const mvp = document.getElementById('testViewport')
    mvp.setAttribute('content', 'width=1230')
    // window.onload = () => {
    //   // window.g_yunaq_login.on('login', () => {
    //   //   window.location.href = '/accounts/login?redirect=/bsafe'
    //   // })
    //   // window.g_yunaq_login.on('register', () => {
    //   //   window.location.href = '/accounts/register?redirect=/bsafe'
    //   // })
    //   // window.g_yunaq_login.on('logout', () => {
    //   //   localStorage.removeItem('SCLOUD_TOKEN_INFO')
    //   //   localStorage.removeItem(storage.KEYS.tokenInfo)
    //   //   window.location.href = '/bsafe'
    //   // })
    //   // if (!this.loginVis) {
    //   //   window.g_yunaq_login.renderLogged(`${this.userName}`)
    //   //   window.g_report_access_behavior(this.userName)
    //   // } else {
    //   //   window.g_yunaq_login.renderLogged()
    //   // }
    //   window.g_yunaq_login.renderLogged(`${'wangy16'}`)
    //   window.g_report_access_behavior('wangy16')
    // }
  },
}
</script>

<style lang="scss">
.pc_home {
  color: #333333;
  .home_banner {
    background-image: url('../../../assets/images/neirong/banner@2x.png');
    background-position: center;
    background-size: cover;
    height: 380px;
    min-width: 1230px;
    text-align: left;
    .home_banner_info {
      width: 1200px;
      margin: 0 auto;
      height: 380px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        font-size: 32px;
        color: #ecedf4;
        margin-bottom: 30px;
      }
      h2 {
        font-size: 16px;
        color: #979bb6;
      }
      // .home_banner_btn {
      //   width: 165px;
      //   height: 53px;
      //   margin-top: 40px;
      //   cursor: pointer;
      //   &:hover {
      //     opacity: 0.9;
      //   }
      // }
      .home_banner_btn {
        width: 165px;
        height: 53px;
        margin-top: 40px;
        cursor: pointer;
        background: url('../../../assets/images/neirong/ljzx_bg@2x.png')
          no-repeat;
        background-size: 165px 53px;
        &:hover {
          opacity: 0.9;
        }
        p {
          color: #fff;
          text-align: center;
          line-height: 53px;
          font-size: 18px;
        }
      }
    }
  }
  .home_titlenav {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1230px;
    height: 108px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    nav {
      transition: 5s;
      font-size: 22px;
      margin-right: 65px;
      cursor: pointer;
      i {
        display: block;
        visibility: hidden;
        width: 50%;
        margin-left: 25%;
        height: 2px;
        background: #0a9efa;
        transition: 0.3s linear;
        margin-top: 6px;
      }
      &:hover {
        i {
          visibility: visible;
          transform: scaleX(2);
        }
      }
    }
    .nav_active {
      i {
        width: 50%;
        transform: scaleX(2);
        visibility: visible;
      }
    }
  }
  .home_center {
    background: #f6f8fb;
    padding-bottom: 74px;
    padding-top: 60px;
    min-width: 1230px;
    .home_center_section {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      margin-top: 160px;
      .hcs_info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        h1 {
          font-size: 22px;
        }
        h2 {
          color: #666;
          font-size: 16px;
          line-height: 26px;
        }
        .hcs_btn {
          width: 160px;
          height: 48px;
          background: rgba(10, 158, 250, 1);
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 18px;
          margin-top: 48px;
          cursor: pointer;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
    .home_center_section1 {
      margin-top: 0;
      img {
        width: 500px;
        height: 532px;
      }
    }
    .home_center_section2 {
      img {
        width: 674px;
        height: 533px;
      }
    }
    .home_center_section3 {
      img {
        width: 605px;
        height: 533px;
      }
    }
  }
  .home_bottom {
    background: #fff;
    padding-top: 80px;
    padding-bottom: 76px;
    min-width: 1230px;
    h1 {
      font-size: 30px;
    }
    img {
      width: 200px;
      height: 160px;
      margin-right: 30px;
    }
    .home_bottom_section {
      display: flex;
      justify-content: center;
      img {
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .home_bottom_section1 {
      margin-top: 64px;
    }
    .home_bottom_section2 {
      margin-top: 32px;
    }
  }
}
.yaq-header {
  min-width: 1230px;
}
.yaq-footer {
  min-width: 1230px;
}
</style>
